import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import ContratoModel from "@/models/contratos/contrato.model";
import {ContratoFilter} from "@/models/contratos/contrato-filter.interface";
import queryUtil from '@/util/query.util';

class ContratoService {

    STATUS_OK: number = 200;

    async cadastrar(body: ContratoModel): Promise<any> {
        return await Vue.prototype.$axios.post('contratos', body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Dados salvos com sucesso!');
                    const contrato: ContratoModel = response.data;
                    return contrato;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async atualizar(body: ContratoModel): Promise<any> {
        return await Vue.prototype.$axios.put(`contratos/${body.id}`, body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Dados atualizados com sucesso!');
                    const contrato: ContratoModel = response.data;
                    return contrato;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async buscarComFiltro(filtro: ContratoFilter | undefined): Promise<any> {
        const query = queryUtil.getQuery(filtro);
        return await Vue.prototype.$axios.get(`filter/contratos${query}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<ContratoModel> = response.data;
                    if (lista.length === 0) {
                        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhum contrato encontrado');
                    }
                    return lista;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar a lista de contratos');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async get(id: string): Promise<any> {
        return await Vue.prototype.$axios.get(`contratos/${id}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const contrato: ContratoModel = response.data;
                    return contrato;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar contrato');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }

    async delete(id: number | null): Promise<any> {
        await Vue.prototype.$axios.delete(`contratos/${id}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Contrato deletado com sucesso!');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
            });
    }


}

export default new ContratoService();
